import { action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore, { LOADED, LOADING } from 'stores/BaseStore';
import settingStore from 'modules/cms/stores/setting';

class PageStore extends BaseStore {
  constructor() {
    super('cms/posts', 'cms/post', { site_model: true });
    this.editingVersion = null
  }

  editVersion(version) {
    this.editingVersion = version
  }

  get isEditingVersion() {
    return !!this.editingVersion
  }

  get postData() {
    if (!this.isEditingVersion)
      return this.entity.object

    if (this.entity.object)
      return { ...this.entity.object, ...this.editingVersion, id: this.entity.object.id }

    return null
  }

  get versions() {
    if (this.entity.object)
      return this.entity.object.versions
    return null
  }

  @action image(file) {
    let data = new FormData();
    data.append('image', file);

    return (
      HttpClient.post(`${this.collectionURL}/image`, data)
        .then((response) => {
          return response.data;
        })
    );
  }

  @action save(object, params, forceVersionUpdateId = null) {
    if (!this.isEditingVersion && !forceVersionUpdateId)
      return super.save(object, params)

    return HttpClient.put(`${config.api}/${this.entityName}/${this.entity.object.id}/versions/${forceVersionUpdateId || this.editingVersion.id}`, object)
      .then(action(response => {
        this.editingVersion = response.data;
        this.entity.readyState = LOADED;
        return response;
      })).catch(response => { throw response });
  }

  async createVersion(data) {
    if (!this.entity.object)
      return null

    const { title, content, template, custom, featured_image, active, content_type, site_id, id: cms_post_id } = this.entity.object
    const payload = { title, content, template, custom, featured_image, active, content_type, site_id, cms_post_id }

    const response = await HttpClient.post(`${config.api}/${this.entityName}/${this.entity.object.id}/version`, { ...data, ...payload })
    return response.data;
  }

  async deleteVersion(cmsPostVersionId) {
    if (!this.entity.object)
      return null

    const { id: cmsPostId, site_id: siteId } = this.entity.object

    const response = await HttpClient.delete(`${config.api}/${this.entityName}/${cmsPostId}/versions/${cmsPostVersionId}`, { siteId })
    return response.data;
  }

  getTemplates = settingStore.getTemplates()

  async references(postId) {
    const params = { site_id: this.getCurrentSiteID() }
    this.entity.readyState = LOADING;
    const { data } = await HttpClient.get(`${config.api}/${this.entityName}/${postId}/references`, { params })
    this.entity.readyState = LOADED;
    return data;
  }
}

export default new PageStore();
